import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'ReviewPage.title',
    defaultMessage: 'Confirm withdrawal',
    description: 'Title for review page',
  },
  description: {
    id: 'ReviewPage.description',
    defaultMessage: `We will send your balances to the crypto wallet you provided.`,
    description: 'Description text prompting user to review their withdrawal',
  },
  tableCaption: {
    id: 'ReviewPage.tableCaption',
    defaultMessage: 'Review your withdrawal',
    description: 'Caption for review table',
  },
  asset: {
    id: 'ReviewPage.asset',
    defaultMessage: 'Asset',
    description: 'Asset label',
  },
  coinbaseFee: {
    id: 'ReviewPage.coinbaseFee',
    defaultMessage: 'Coinbase fee',
    description: 'Coinbase fee label',
  },
  coinbaseFeeTooltip: {
    id: 'ReviewPage.coinbaseFeeTooltip',
    defaultMessage: '1% fee from payments received included in withdrawal',
    description: 'Coinbase fee tooltip',
  },
  networkFee: {
    id: 'ReviewPage.networkFee',
    defaultMessage: 'Network fee',
    description: 'Network fee label',
  },
  networkFeeTooltip: {
    id: 'ReviewPage.networkFeeTooltip',
    defaultMessage: 'Charged by the network to process the transaction',
    description: 'Network fee tooltip',
  },
  balance: {
    id: 'ReviewPage.balance',
    defaultMessage: 'Balance',
    description: 'Balance label',
  },

  totalNetworkFee: {
    id: 'ReviewPage.totalNetworkFee',
    defaultMessage: 'Total network fee',
    description: 'Total network fee label',
  },
  totalNetworkFeeTooltip: {
    id: 'ReviewPage.totalNetworkFeeTooltip',
    defaultMessage: 'Includes network fees from all assets',
    description: 'Total network fee tooltip',
  },
  totalCoinbaseFee: {
    id: 'ReviewPage.totalCoinbaseFee',
    defaultMessage: 'Total Coinbase fee',
    description: 'Total Coinbase fee label',
  },
  sendTime: {
    id: 'ReviewPage.sendTime',
    defaultMessage: 'Send time (estimate)',
    description: 'Send time label',
  },
  totalProceeds: {
    id: 'ReviewPage.totalProceeds',
    defaultMessage: 'Total proceeds',
    description: 'Total proceeds label',
  },
  totalProceedsTooltip: {
    id: 'ReviewPage.totalProceedsTooltip',
    defaultMessage: 'Amount you will receive after network fees',
    description: 'Total proceeds tooltip',
  },
  toAddressLabel: {
    id: 'ReviewPage.toAddressLabel',
    defaultMessage: 'To address',
    description: 'To address label',
  },
  back: {
    id: 'ReviewPage.back',
    defaultMessage: 'Back',
    description: 'Back button text',
  },
  withdraw: {
    id: 'ReviewPage.withdraw',
    defaultMessage: 'Withdraw',
    description: 'Withdraw button text',
  },
  noTransactionsErrorToast: {
    id: 'ReviewPage.noTransactionsErrorToast',
    defaultMessage: 'No transactions to review, please re-enter your seed phrase.',
    description:
      'Message shown when the user needs to start over because there are no transactions',
  },
  noSeedPhraseErrorToast: {
    id: 'ReviewPage.noSeedPhraseErrorToast',
    defaultMessage: 'No seed phrase present, please enter it again.',
    description: 'Message shown when the user needs to start over because there is no seed phrase',
  },
  problemSigningErrorToast: {
    id: 'ReviewPage.problemSigningErrorToast',
    defaultMessage: 'Problem signing, please try again.',
    description:
      'Message shown when the user needs to start over because there was an error signing the transactions',
  },
});
